import ErrorBoundary from '@/components/ErrorBoundary'
import { createHead, UnheadProvider } from '@unhead/react/client'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Suspense } from 'react'
import ClientApp from './ClientApp.tsx'
import './index.css'

const head = createHead()
const rootEl = typeof document !== 'undefined' ? document.getElementById('root') : null

if (rootEl) {
  createRoot(rootEl).render(
    <ErrorBoundary>
      <UnheadProvider head={head}>
        <BrowserRouter>
          <ErrorBoundary>
            <Suspense fallback={<div className="min-h-screen bg-zinc-950 flex items-center justify-center text-stone-400 text-sm">載入中...</div>}>
              <ClientApp />
            </Suspense>
          </ErrorBoundary>
        </BrowserRouter>
      </UnheadProvider>
    </ErrorBoundary>,
  )
}
